import axiosClient from '../axiosClient';

const withdrawAPI = {
    async sendWithdraw(params) {
        const url = `/user/withdraw`;
        const resp = await axiosClient.post(url, params);
        return resp;
    },
};

export default withdrawAPI;
